module.exports = __webpack_public_path__ + "static/bar02_1_mobile-3a5ccb7947c75faee6e6dbb3ad15f965.png";